const MODAL_ID = "student-choice-excluded-content-modal";

export function showStudentChoiceExcludedContentModal() {
  const el = document.getElementById(MODAL_ID);
  if (!el) return;
  el.classList.remove("hidden");
  el.classList.add("open");
}

export function hideStudentChoiceExcludedContentModal() {
  const el = document.getElementById(MODAL_ID);
  if (!el) return;
  el.classList.remove("open");
  el.classList.add("hidden");
}

export function studentChoiceExcludedContentResponse(response, data) {
  return response.status === 422 && data?.error === "student_choice_excluded_content";
}
